import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Typography from '@mui/material/Typography';
import { Controller, useFormContext } from 'react-hook-form';
import { z } from 'zod';

export const ProductsSortFormSchema = z.object({
  sortOrder: z.enum(['asc', 'desc']),
});

export type ProductsSortFormInputs = z.infer<typeof ProductsSortFormSchema>;

const ProductsSortForm: React.FC = () => {
  const { control } = useFormContext<ProductsSortFormInputs>();

  return (
    <Box>
      <Typography variant="subtitle2">Sort by</Typography>
      <Controller
        name="sortOrder"
        control={control}
        render={({ field }) => (
          <RadioGroup {...field} row>
            <FormControlLabel
              value="asc"
              control={<Radio value={'asc'} size="small" />}
              label={
                <Typography variant="caption">Price: low to high</Typography>
              }
            />
            <FormControlLabel
              value="desc"
              control={<Radio value={'desc'} size="small" />}
              label={
                <Typography variant="caption">Price: high to low</Typography>
              }
            />
          </RadioGroup>
        )}
      />
    </Box>
  );
};

export default ProductsSortForm;
